export default __webpack_public_path__ + "static/media/IMG-20240729-WA0018.7c5e40ee.jpg";